module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-02-b83dd115bc2b288f278c49a28f5c55c6.jpg";